module.exports = __webpack_public_path__ + "static/awcomp-7f0678730893b1dbc75da37205d5e272.svg";